import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const MONOGRAM =
  "https://customer-assets-agu9un31.emergentagent.net/job_formation-dashboard/artifacts/o5lfjpbs_Intrinsic_Daily_Monogram.png";

/*
 * "Start over" placeholder. Shown at "/" (public) and "/dashboard" (authenticated
 * landing) while the product is being rebuilt. All previous pages remain in the
 * codebase but are intentionally unrouted (see App.js).
 */
export default function ComingSoon() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = !!(user && (user.is_admin || user.is_master));

  const signOut = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="id-surface relative flex min-h-screen flex-col items-center justify-center px-6" data-testid="coming-soon-page">
      <div className="flex flex-col items-center text-center">
        <img src={MONOGRAM} alt="Intrinsic Daily" className="h-16 w-auto object-contain" />
        <h1 className="id-serif mt-6 text-4xl sm:text-5xl text-[var(--id-charcoal)]">Intrinsic Daily</h1>

        <div className="my-6 flex items-center gap-4">
          <span className="h-px w-10 bg-[var(--id-mist)]" />
          <span className="id-sans text-[11px] uppercase tracking-[0.28em] text-[var(--id-charcoal)]/50">Coming soon</span>
          <span className="h-px w-10 bg-[var(--id-mist)]" />
        </div>

        <p className="id-serif max-w-md text-xl leading-relaxed text-[var(--id-charcoal)]/75">
          Something intentional is being built.
        </p>
        <p className="id-sans mt-3 max-w-md text-sm text-[var(--id-charcoal)]/55">
          Grow with intention. Live each day on purpose.
        </p>
      </div>

      {/* Discreet account controls — auth stays fully accessible during the rebuild */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        {user ? (
          <div className="flex flex-wrap items-center justify-center gap-4">
            <span className="id-sans text-xs text-[var(--id-charcoal)]/50" data-testid="coming-soon-signed-in">
              Signed in as {user.email}
            </span>
            {isAdmin && (
              <Link
                to="/admin"
                data-testid="coming-soon-admin-link"
                className="id-sans inline-flex items-center gap-1.5 text-xs font-medium text-[var(--id-walnut)] id-link-underline">
                <ShieldCheck size={14} /> Admin
              </Link>
            )}
            <button
              onClick={signOut}
              data-testid="coming-soon-signout"
              className="id-sans inline-flex items-center gap-1.5 text-xs font-medium text-[var(--id-walnut)] id-link-underline">
              <LogOut size={14} /> Sign out
            </button>
          </div>
        ) : (
          <Link
            to="/login"
            data-testid="coming-soon-signin-link"
            className="id-sans text-xs font-medium text-[var(--id-walnut)] id-link-underline">
            Sign in
          </Link>
        )}
      </div>
    </div>
  );
}
